import script from "./Sources.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sources.vue?vue&type=script&setup=true&lang=ts"

import "./Sources.vue?vue&type=style&index=0&id=2f435d26&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f435d26"]])

export default __exports__